import rawToast from 'react-hot-toast';

const getToastId = (type, message, options = {}) => {
  if (options?.id) return options.id;
  if (typeof message === 'string' && message.trim()) {
    return `${type}:${message.trim().toLowerCase()}`;
  }
  return undefined;
};

const toast = Object.assign(
  (message, options = {}) => rawToast(message, { ...options, id: getToastId('default', message, options) }),
  rawToast,
  {
    success: (message, options = {}) =>
      rawToast.success(message, { ...options, id: getToastId('success', message, options) }),
    error: (message, options = {}) =>
      rawToast.error(message, { ...options, id: getToastId('error', message, options) }),
    loading: (message, options = {}) =>
      rawToast.loading(message, { ...options, id: getToastId('loading', message, options) })
  }
);

export default toast;
